import { render, staticRenderFns } from "./typeDetail.vue?vue&type=template&id=a0d633a0&scoped=true&"
import script from "./typeDetail.vue?vue&type=script&lang=js&"
export * from "./typeDetail.vue?vue&type=script&lang=js&"
import style0 from "./typeDetail.vue?vue&type=style&index=0&id=a0d633a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d633a0",
  null
  
)

export default component.exports